import { MultiuserTokenService } from '../lib/multiuserTokenSevise';

export const CART_PARAM = 'id';
export const TOKEN_PARAM = 'tok';

export const getInviteLink = () => {
  //TODO надо будет зашифровать дату (https://www.notion.so/ig/af5fce3a009e4bfea103e252f7f13176#256755fdc1b74729ab48120672930b93)
  const cartInfo = MultiuserTokenService.get();
  if (cartInfo && cartInfo.token) {
    return `${window.location.href}?${CART_PARAM}=${cartInfo.cartId}&${TOKEN_PARAM}=${cartInfo.token}`;
  }
  return '';
};
